export default __webpack_public_path__ + "static/media/VISA_card.c9eb5bb1.svg";